import gsap from 'gsap';

import Component from '../base/component';
import { toggleClass } from '../base/dom-utils';

class ScrollIco extends Component {

    constructor(el, opts) {
        super(el, opts);
    }

    beforeInit() {

        const scrollbarInstance = this.options.scrollbarInstance;

        if (scrollbarInstance) {

            scrollbarInstance.addListener(() => {

                if (scrollbarInstance.scrollTop >= 80) {

                    toggleClass(this.$el, 'is-scrolled', true);

                    gsap.to(this.$el, 0.25, {
                        autoAlpha: 0
                    });

                } else {

                    toggleClass(this.$el, 'is-scrolled', false);

                    gsap.to(this.$el, 0.25, {
                        autoAlpha: 1
                    });

                }

            });

        }

        this.delegate('click', '#scroll-down', (e) => {
            e.preventDefault();

            const scrollbarInstance = this.options.scrollbarInstance;

            if (scrollbarInstance) {
                const scrollTop = scrollbarInstance.getSize().container.height;
                scrollbarInstance.scrollTo(0, scrollTop, 850);
            }
        });

    }

    getDefaultOptions() {
        return {
            scrollbarInstance: null
        }
    }

}

export default ScrollIco;


/** WEBPACK FOOTER **
 ** ./components/scroll-ico.js
 **/